export default {
    // advertising.vue
    advertising_show: '显示' /*显示状态*/,
    advertising_hide: '隐藏' /*隐藏状态*/,
    advertising_content_management: '内容管理' /*内容管理按钮*/,
    advertising_position: '广告位置' /*广告位置列标题*/,
    advertising_views: '浏览量' /*浏览量列标题*/,

    // banner.vue
    banner_add: '新 增' /*新增按钮*/,
    banner_query: '查询' /*查询按钮（已注释）*/,
    banner_edit: '编辑' /*编辑按钮*/,
    banner_delete: '删除' /*删除按钮*/,
    banner_confirm_delete: '确定删除该banner吗？' /*删除确认提示*/,
    banner_confirm: '确定' /*确认对话框确认按钮*/,
    banner_cancel: '取消' /*确认对话框取消按钮*/,
    banner_title: '标题' /*标题列标题*/,
    banner_image: '图片' /*图片列标题*/,
    banner_create_time: '创建时间' /*创建时间列标题*/,
    banner_operation: '操作' /*操作列标题*/,
    banner_title_required: '请输入标题',
    banner_title_vice_required: '请输入副标题',
    banner_title_vice: '副标题' /*副标题列标题*/,
    banner_image_scale: '缩略图' /*缩略图列标题*/,

    // info.vue
    info_clear_cache: '清除缓存' /*清除缓存按钮*/,
    info_loading: 'Loading...' /*加载提示*/,
    info_website_cache: '微官网首页缓存' /*微官网首页缓存标签*/,
    info_views_count: '浏览数量' /*浏览量标签*/,
    info_share_count: '转发数量' /*转发量标签*/,
    info_view_website: '查看微网站' /*查看微网站链接文本*/,
    info_website_status: '微官网状态' /*微官网状态标签*/,
    info_website_title: '微官网标题' /*微官网标题标签*/,
    info_website_title_required: '请输入微官网标题' /*微官网标题输入提示*/,
    info_copyright: '底部版权说明' /*底部版权说明标签*/,
    info_copyright_required: '请输入底部版权说明' /*底部版权说明输入提示*/,
    info_countdown: '是否开启倒计时' /*倒计时开关标签*/,
    info_countdown_type: '倒计时类型' /*倒计时类型标签*/,
    info_countdown_bg_color: '倒计时背景色' /*倒计时背景色标签*/,
    info_countdown_font_color: '倒计时文字颜色' /*倒计时文字颜色标签*/,
    info_welcome_page: '是否显示欢迎页' /*是否显示欢迎页标签*/,
    info_show_jump_button: '是否显示跳转按钮' /*是否显示跳转按钮标签*/,
    info_welcome_image: '欢迎页图片' /*欢迎页图片标签*/,
    info_jump_link: '欢迎页跳转链接' /*欢迎页跳转链接标签*/,
    info_show_countdown_time: '是否显示跳转时间' /*是否显示跳转时间标签*/,
    info_stay_time: '页面停留时间' /*页面停留时间标签*/,
    info_show_footer_pc: '是否显示首页底部(PC)' /*是否显示首页底部标签*/,
    info_show_signup_bar: '二级页是否显示报名栏' /*二级页是否显示报名栏标签*/,
    info_show_homepage_bg: '二级页是否显示首页背景图' /*二级页是否显示首页背景图标签*/,
    info_background_music: '是否开通背景音乐' /*是否开通背景音乐标签*/,
    info_audio_file: '音频文件' /*音频文件标签*/,
    info_audio_file_tips: '支持扩展名： .mp3、.m4a' /*音频文件提示*/,
    info_upload_audio: '上传音频' /*上传音频按钮*/,
    info_submit: '立即提交' /*立即提交按钮*/,
    info_clear_cache_tips: '更新微官网内容后，若网页数据未变更，请点击清除缓存' /*清除缓存提示信息*/,
    info_upload_image: '请上传图片' /*上传图片提示*/,
    info_image_size_tips: '建议尺寸 1080*1700。支持JPG,GIF,PNG图片文件，且文件小于1M。(注：该图片为首页加载前显示的图片)' /*图片尺寸提示*/,
    info_input_link: '请输入跳转链接' /*跳转链接输入提示*/,
    info_http_link_tips: '请输入带有http:// 或 https:// 的链接' /*链接格式提示*/,
    info_unit_seconds: '单位：秒' /*单位提示*/,
    info_open: '开启' /*开启选项*/,
    info_close: '关闭' /*关闭选项*/,
    open: '开通',
    no_open: '不开通',
    info_display_auto_redirect: '开启-网站自动跳转' /*开启-网站自动跳转选项*/,
    info_display_no_auto_redirect: '开启-网站不自动跳转' /*开启-网站不自动跳转选项*/,
    info_show: '显示' /*显示选项*/,
    info_hide: '隐藏' /*隐藏选项*/,
    info_enable: '开通' /*开通选项*/,
    info_disable: '不开通' /*不开通选项*/,

    // nav-list.vue
    nav_list_add: '新 增' /*新增按钮*/,
    nav_list_add_sub: '增加子栏目' /*增加子栏目按钮*/,
    nav_list_edit: '编辑' /*编辑按钮*/,
    nav_list_manage_content: '管理内容' /*管理内容按钮*/,
    nav_list_delete: '删除' /*删除按钮*/,
    nav_list_confirm_delete: '确定删除该栏目吗？' /*删除确认提示*/,
    nav_list_confirm: '确定' /*确认对话框确认按钮*/,
    nav_list_cancel: '取消' /*确认对话框取消按钮*/,
    nav_list_menu_name: '导航菜单名称' /*导航菜单名称列标题*/,
    nav_list_icon: '图标' /*图标列标题*/,
    nav_list_column_type: '栏目类型' /*栏目类型列标题*/,
    nav_list_hidden: '是否隐藏' /*是否隐藏状态列标题*/,
    nav_list_sub_items: '添加子栏目' /*添加子栏目操作列标题*/,
    nav_list_views: '访问量' /*访问量列标题*/,
    nav_list_operation: '操作' /*操作列标题*/,
    nav_list_display: '显示' /*显示状态*/,
    nav_list_hide: '隐藏' /*隐藏状态*/,
    nav_list_not_supported: '暂不支持此类型' /*不支持类型的提示信息*/,

    // share.vue
    share_link: '分享链接' /*分享链接输入框标签*/,
    please_input_share_link: '请输入分享链接',
    share_copy: '复制' /*复制链接按钮*/,
    share_submit: '立即提交' /*提交按钮*/,
    share_enter_link: '清输入分享链接' /*输入验证提示*/,
    share_wechat_title: '微信分享标题' /*微信分享标题输入框标签*/,
    share_wechat_desc: '微信分享描述' /*微信分享描述输入框标签*/,
    share_default_desc: '如分享描述为空，默认显示直播介绍。如需换行请输入\n' /*分享描述提示*/,
    share_warning: '注意：请勿从别处复制粘贴过来，否则回导致分享失败！' /*输入警告*/,
    share_wechat_nickname: '微信昵称' /*示例文本*/,
    share_qrcode: '扫描二维码分享网站' /*二维码说明*/,
    share_qrcode_generator: '二维码生成器' /*二维码生成器链接文本*/,
    share_mini_program: '扫描小程序码分享网站' /*小程序码说明*/,
    share_friend_preview: '好友分享预览' /*好友分享预览标题*/,
    share_circle_preview: '朋友圈预览' /*朋友圈预览标题*/,
    please_input_share_content: '请输入分享内容',
    please_input_share_description: '请输入分享描述',
    if_the_share_description_is_empty_the_default_display_live_introduction: '如分享描述为空，默认显示直播介绍。如需换行请输入\n',
    note_do_not_copy_and_paste_from_elsewhere_otherwise_the_share_will_fail: '注意：请勿从别处复制粘贴过来，否则回导致分享失败！',
    // style.vue
    style_template: '模板选择' /*模板选择输入框标签*/,
    style_home_bg_color: '首页背景颜色' /*首页背景颜色设置*/,
    style_home_bg_image: '首页背景图片' /*首页背景图片上传*/,
    style_nav_icon_color: '导航图标文字颜色' /*导航图标文字颜色设置*/,
    style_nav_font_size: '导航字体大小' /*导航字体大小设置*/,
    style_subnav_display: '二级栏目展现形式' /*二级栏目展现形式*/,
    style_nav_bold: '导航字体是否加粗' /*导航字体是否加粗设置*/,
    bold: '加粗',
    not_bold: '不加粗',
    style_subnav_bg_color: '二级页面导航背景颜色' /*二级页面导航背景颜色设置*/,
    style_subnav_font_color: '二级页面导航字体颜色' /*二级页面导航字体颜色设置*/,
    style_home_advert_color: '首页文字广告背景颜色' /*首页文字广告背景颜色设置*/,
    style_save: '保存' /*保存按钮*/,
    style_clear: '清 除' /*清除图片按钮*/,
    style_select_template: '请选择模板' /*模板选择验证提示*/,
    style_home_bg_required: '首页背景颜色不能为空' /*颜色选择验证提示*/,
    style_advert_color_required: '首页文字广告背景颜色不能为空' /*颜色选择验证提示*/,
    style_nav_icon_color_required: '导航图标文字颜色不能为空' /*颜色选择验证提示*/,
    style_subnav_bg_required: '二级页面导航背景颜色不能为空' /*颜色选择验证提示*/,
    style_subnav_font_required: '二级页面导航字体颜色不能为空' /*颜色选择验证提示*/,
    style_image_format_tips: '支持JPG,GIF,PNG图片文件,不需要背景图片请清空支持扩展名（建议尺寸：1080 × 1920）' /*图片上传提示*/,
    style_image_only: '您只能上传图像文件' /*文件类型验证提示*/,

    // 公共
    common_yes: '是' /*通用是选项*/,
    common_no: '否' /*通用否选项*/,
    please_upload_remittance_certificate: '请上传汇款凭证',
    welcome_page_image_required: '请上传图片' /*欢迎页图片上传验证提示*/,
    adv_edit: {
        title: '编辑广告',
        add_adv: '添加广告',
        adv_title: '文字轮播内容',
        adv_title_required: '请输入文字轮播内容',
        adv_title_tips: '字数控制在25个左右',
        adv_url: '跳转地址',
        adv_url_required: '请输入链接地址',
        adv_url_tips: '格式以 http:// 或 https:// 开头, 不填写则不跳转！',
        adv_add: '添加广告'
    },
    adv_list: {
        title: '广告列表',
        add_adv: '新建广告',
        adv_title: '标题',
        adv_title_vice: '副标题',
        adv_click: '点击量',
        adv_status: '状态',
        adv_create_time: '创建时间',
        adv_create_user: '创建人',
        adv_sort_success: '排序成功',
        adv_delete_confirm: '确定删除该广告吗？'
    },
    banner_info: {
        title: '标题',
        title_required: '请输入标题',
        image: '焦点图',
        image_required: '请上传图片',
        image_tips: '支持JPG、GIF、PNG图片文件, 建议尺寸 900*500',
        image_scale: '缩略图',
        image_scale_required: '请上传缩略图',
        image_scale_tips: '支持JPG、GIF、PNG图片文件, 建议尺寸 900*500',
        upload_image: '上传图片',
        clear_image: '清 除',
        link: '链接',
        link_required: '请输入带有 http:// 或 https:// 的链接',
        sort: '排序',
        submit: '立即提交'
    },
    guest_info: {
        name: '姓名',
        name_required: '请输入姓名',
        photo: '照片',
        photo_required: '请上传照片',
        photo_tips: '150*150px，支持JPG,GIF,PNG图片文件，大于500K会被自动压缩',
        upload_photo: '上传照片',
        clear_photo: '清 除',
        company: '单位',
        title: '职称',
        position: '职务',
        sort: '排序',
        link: '外部链接',
        link_required: '请输入带有 http:// 或 https:// 的链接',
        content: '简介',
        content_required: '请输入简介',
        submit: '立即提交'
    },
    guest_list: {
        title: '嘉宾列表',
        delete_confirm: '您确定要删除【{name}】吗？'
    },
    image_info: {
        title: '标题',
        title_required: '请输入标题',
        image: '上传图片',
        image_required: '请上传图片',
        image_tips: '支持JPG、GIF、PNG图片文件, 建议尺寸 900*500',
        link: '跳转链接',
        link_required: '请输入带有 http:// 或 https:// 的链接',
        submit: '立即提交',
        sort: '排序',
        image_edit: '图片编辑',
        image_text: '图片',
        image_list: '图片列表'
    },
    nav_list_edit: {
        title: '导航菜单名称',
        title_required: '请输入栏目名称',
        vice_title: '副标题',
        is_system_icon: '是否使用系统图标',
        is_system_icon_required: '请选择是否显示',
        is_system_icon_yes: '是',
        is_system_icon_no: '否',
        select_system_icon: '请选择系统图标',
        upload_image: '上传图片',
        upload_image_required: '请上传图片',
        upload_image_tips: '建议尺寸 300*300。支持JPG,GIF,PNG图片文件，且文件小于2M',
        clear_image: '清 除',
        nav_bg_color: '导航背景颜色',
        nav_bg_color_required: '请选择导航背景颜色',
        nav_font_color: '导航字体颜色',
        nav_font_color_required: '请选择导航字体颜色',
        nav_font_size: '导航字体大小',
        nav_font_size_required: '请选择导航字体大小',
        tips: '注意：当前可以配置透明度了',
        nav_type: '栏目类型',
        nav_type_required: '请选择栏目类型',
        select_time: '选择时间',
        select_time_required: '请选择选择时间',
        content: '内容',
        content_required: '请输入内容',
        nav_url: '跳转链接',
        is_show_time: '页面是否显示时间',
        is_show_time_required: '请选择是否显示',
        is_show_num: '页面是否显示浏览量',
        is_anonymous_msg: '是否匿名留言',
        is_anonymous_msg_required: '请选择是否是否匿名留言',
        sort: '排序',
        sort_tips: '值越小越靠前',
        sort_required: '请输入排序',
        submit: '立即提交',
        nav_list_edit: '栏目编辑',
        nav_list_add: '新增栏目',
        upload_image_tips_news: '180*180px，支持JPG,GIF,PNG图片文件'
    },
    show_hide: '显示|隐藏',
    create_time: '创建时间',
    news_list: '新闻列表',
    delete_confirm: '确定删除该条吗？',
    welcome_page_image_tips: '建议尺寸 1080*1700。支持JPG,GIF,PNG图片文件，且文件小于1M。(注：该图片为首页加载前显示的图片)',
    default: '默认'
};
